import { endOfDay, isAfter } from 'date-fns';
import { Col } from '../../col';
import { Icon } from '../../icon';
import { Row } from '../../row';
import { Tag } from '../../tag';
import { Text } from '../../typography';
import type { TagMode } from '../WidgetItem';
import { type FormattedTimeConfig, WidgetItemTimeText } from './widget-item-time-text';

type P = {
  activeDate: Date;
  alwaysShowTimeTag?: boolean;
  noPadding?: boolean;
  tags?: TagMode[];
  timeConfig: FormattedTimeConfig;
};

const WidgetItemTimeTag = ({ activeDate, alwaysShowTimeTag = false, noPadding, tags, timeConfig }: P) => {
  const shouldSkipTimeTag = alwaysShowTimeTag
    ? false
    : timeConfig.options.display === 'hidden' ||
      (timeConfig.options.display === 'time' && isAfter(timeConfig.time, endOfDay(activeDate)));

  if (shouldSkipTimeTag) {
    return null;
  }

  const isLive = tags?.includes('live');

  return (
    <Row gutter="xs">
      {isLive ? (
        <Col>
          <Tag color="critical" format={{ upperCase: true }} icon={<Icon icon="radar-line" />} size="compact">
            time_tag_live
          </Tag>
        </Col>
      ) : null}
      <Col>
        <Tag icon={<Icon icon="time-line" />} noBackground noPadding={noPadding}>
          <Text size="small">
            <WidgetItemTimeText timeConfig={timeConfig} />
          </Text>
        </Tag>
      </Col>
    </Row>
  );
};

export default WidgetItemTimeTag;
